import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const HeartInsideCircleIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M10.0013 1.66675C5.4063 1.66675 1.66797 5.40508 1.66797 10.0001C1.66797 14.5951 5.4063 18.3334 10.0013 18.3334C14.5963 18.3334 18.3346 14.5951 18.3346 10.0001C18.3346 5.40508 14.5963 1.66675 10.0013 1.66675ZM11.3846 12.3659L11.2405 12.4967C11.033 12.6901 10.6946 12.9542 10.3646 13.1992C10.1488 13.3601 9.8538 13.3601 9.63797 13.1992C9.30714 12.9526 8.96547 12.6867 8.7538 12.4884L8.6163 12.3634C7.4513 11.3101 6.19714 9.92508 6.84714 8.56675C7.15214 7.93008 7.81547 7.50092 8.49964 7.50008C8.87964 7.50008 9.23464 7.60342 9.5538 7.80675L10.0013 8.09258L10.4496 7.80675C10.7688 7.60342 11.123 7.50008 11.503 7.50008H11.5055C12.1871 7.50092 12.8505 7.93008 13.1555 8.56675C13.8063 9.92508 12.5513 11.3101 11.3846 12.3659Z"
      fill={props.sx?.color || '#FF524F'}
    />
  </SvgIcon>
);

HeartInsideCircleIcon.propTypes = {
  sx: PropTypes.object,
};

export default HeartInsideCircleIcon;
